import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ScopeAndSequence from "Course/routes/ScopeAndSequence";
import TeacherSetup from "TeacherSetup";
import Courses from "./routes/Courses";
import Class from "./routes/Class";
import LearningCourses from "./routes/LearningCourses";
import LearningCourse from "./routes/LearningCourse";
import ClassRoomTodos from "./routes/ClassRoomTodos";
import Projects from "./routes/Projects";
import { CircularRoutes } from "../Administrator/routes";
import ParentJournal from "./routes/ParentJournal";
import NotificationSettings from "./routes/NotificationSettings";
import AIPlayground from "./routes/AIPlayground";
import FamilyConversations from "FamilyConversations";
import ParentProgressReport from "./routes/ParentProgressReport";
import { FamilyPortalSchoolPolicy } from "OrganizationResources";
import ProgressReportSets from "./routes/ProgressReportSets";
import ProductUpdates from "./routes/ProductUpdates";
import ProductUpdatesV2 from "./routes/ProductUpdatesV2";
import ToddleAcademy from "./routes/ToddleAcademy";
import Todos from "./routes/Todos";
import StudentProgressSummary from "./routes/StudentProgressSummary";
import ManageUnitPublishing from "./routes/ManageUnitPublishing";
import SubjectCenter from "./routes/SubjectCenter";
import ContentSkills from "./routes/ContentSkills";
import Timetable from "./routes/Timetable";
import AttendanceSummary from "./routes/AttendanceSummary";
import ProjectGroupTypes from "./routes/ProjectGroupTypes";
import LearnerPortfolio from "./routes/LearnerPortfolio";
import LearnerPortfolioFeed from "./routes/LearnerPortfolioFeed";
import StudentGoals from "./routes/StudentGoals";
import SymLinks from "../Platform/routes/SymLinks";
import ClassStreamManager from "./routes/ClassStreamManager";
import ToddleAnalytics from "./routes/ToddleAnalytics";
import BehaviourManagement from "./routes/BehaviourManagement";
import Incident from "./routes/Incident";
import PortfolioReview from "./routes/PortfolioReview";
import ConsolidatedPortfolioFamilyView from "./routes/ConsolidatedPortfolioFamilyView";
import SchoolLibrary from "./routes/SchoolLibrary";
import TeacherTimeTable from "./routes/TeacherTimeTable";
import MBSponteFeeLTIWidget from "./routes/MBSponteFeeLTIWidget";
import PlanningInsights from "PlanningInsights";
import YearGroup from "Administrator/routes/YearGroup";

import SnP_v2 from "Administrator/routes/SnP_v2";
import SnP from "Administrator/routes/SnP";
import AdminEducatorCenter from "Administrator/routes/AdminEducatorCenter";
import ProfileV2 from "Platform/routes/ProfileV2";
import FamilyProfile from "Platform/routes/FamilyProfile";
import TeacherProfile from "Platform/routes/TeacherProfile";
import MessagingRoutes from "Platform/routes/MessagingV2";
import AttendanceDashboard from "AttendanceDashboard";
import Homeroom from "Homeroom";
import LTIWidget from "./routes/LTIWidget";

import ClassRoomInsights from "ClassRoom/routes/ClassRoomInsights";
import AdminEducatorCenterV2 from "Administrator/routes/AdminEducatorCenterV2";
import TimetableManagerV2 from "Administrator/routes/TimetableManagerV2";
import AdminGradeBook from "Administrator/routes/AdminGradebook";
import CurriculumInsights from "CurriculumInsights";
import CurriculumMaps from "CurriculumMaps";
import StudentPlans from "StudentPlans";

export default store => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(
    () =>
      new Promise((cb, reject) => {
        require.ensure(
          [],
          require => {
            const component = require("./components").default;
            const reducer = require("Teacher/modules/TeacherModule").default;
            injectReducer(store, { key: "teacher", reducer });
            const circularModule = require("Circulars/modules/CircularsModule");
            injectReducer(store, {
              key: circularModule.NAME,
              reducer: circularModule.default,
            });

            const classRoomReducer = require("ClassRoom/modules/ClassRoomModule")
              .default;

            const adminReducer = require("Administrator/modules/AdministratorModule");

            const worksheetModule = require("Worksheet/modules/WorksheetModules");
            const portfolioReviewModule = require("Teacher/routes/PortfolioReview/modules/PortfolioReviewModule");
            const timeTablePlanner = require("TimetablePlanner/modules/TimetablePlannerModule");
            injectReducer(store, {
              key: worksheetModule.NAME,
              reducer: worksheetModule.default,
            });

            injectReducer(store, {
              key: "classRoom",
              reducer: classRoomReducer,
            });

            injectReducer(store, {
              key: adminReducer.NAME,
              reducer: adminReducer.default,
            });

            injectReducer(store, {
              key: portfolioReviewModule.NAME,
              reducer: portfolioReviewModule.default,
            });
            injectReducer(store, {
              key: "timetablePlanner",
              reducer: timeTablePlanner.default,
            });
            cb(component);
          },
          err => {
            reject(err);
          },
          "teacher-course"
        );
      })
  ),

  childRoutes: [
    SymLinks(store),
    Courses(store),
    Class(store),
    LearningCourses(store, true),
    LearningCourse(store),
    ClassRoomTodos(store),
    ScopeAndSequence(store),
    TeacherSetup(store),
    ..._.map(CircularRoutes, comp => comp(store)),
    ParentJournal(store),
    Projects(store),
    ProjectGroupTypes(store),
    NotificationSettings(store),
    AIPlayground(store),
    FamilyConversations(store),
    ParentProgressReport(store),
    FamilyPortalSchoolPolicy(store),
    StudentProgressSummary(store),
    ProgressReportSets(store),
    SnP_v2(store),
    SnP(store),
    ProductUpdates(store),
    ToddleAcademy(store),
    Todos(store),
    ManageUnitPublishing(store),
    SubjectCenter(store),
    ContentSkills(store),
    Timetable(store),
    AttendanceSummary(store),
    AdminEducatorCenter(store),
    AdminEducatorCenterV2(store),
    ProfileV2(store),
    LearnerPortfolio(store),
    FamilyProfile(store),
    TeacherProfile(store),
    LearnerPortfolioFeed(store),
    AttendanceDashboard(store),
    Homeroom(store),
    StudentGoals(store),
    ClassRoomInsights(store),
    ClassStreamManager(store),
    ToddleAnalytics(store),
    BehaviourManagement(store),
    Incident(store),
    PortfolioReview(store),
    SchoolLibrary(store),
    TeacherTimeTable(store),
    ..._.map(MessagingRoutes, comp => comp(store)),
    AdminGradeBook(store),
    ProductUpdatesV2(store),
    LTIWidget(store),
    PlanningInsights(store),
    MBSponteFeeLTIWidget(store),
    TimetableManagerV2(store),
    YearGroup(store),
    ConsolidatedPortfolioFamilyView(store),
    CurriculumInsights(store),
    CurriculumMaps(store),
    StudentPlans(store),
  ],
});
